import { render } from "./constructorWritingComponent.vue?vue&type=template&id=0980a282&scoped=true"
import script from "./constructorWritingComponent.vue?vue&type=script&lang=js"
export * from "./constructorWritingComponent.vue?vue&type=script&lang=js"

import "./constructorWritingComponent.vue?vue&type=style&index=0&id=0980a282&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0980a282"]])

export default __exports__